import UsersManager from "../managers/UsersManager";
import React, {useEffect, useState} from "react";
import {Card, Typography} from "@material-ui/core";
import {yellow} from "@material-ui/core/colors";
import Strings from "../lang/Strings";

export default function NextRollCountDownTimer(props: any) {

    const countDownTimerCallBack = props.callBack;

    const [countDownTimerString, setCountDownTimerString] = useState("");
    const [loaded,] = useState(true);

    const startCountDownTimer = () => {
        let loggedInUser = JSON.parse(UsersManager.getLoggedInUser() as string);
        let lastRollTime = loggedInUser["lastFreeRollGameTime"];
        let x = setInterval(function () {
            let now = new Date().getTime();
            let distance = lastRollTime - now;
            let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            let seconds = Math.floor((distance % (1000 * 60)) / 1000);
            let countDownString = minutes + "m :" + seconds + "s ";
            setCountDownTimerString(countDownString);
            document.title = countDownString + "-" + Strings.APP_NAME;
            if (distance < 0) {
                clearInterval(x);
                countDownTimerCallBack();
            }
        }, 1000);
    }

    useEffect(() => {
        startCountDownTimer();
    }, [loaded]);

    return <div>
        <Card style={{
            paddingLeft: 20,
            paddingRight: 20,
            paddingTop: 10,
            paddingBottom: 10,
            marginTop: 10,
            backgroundColor: yellow[600]
        }}>
            <Typography
                style={{
                    fontSize: 20,
                    fontWeight: 400,
                    paddingTop: 10
                }}
                align={"center"}>Next Roll In:</Typography>
            <Typography
                align={"center"}
                style={{
                    fontWeight: 600,
                    fontSize: 25
                }}>{countDownTimerString}</Typography>
        </Card>
    </div>

}